<div class="sales-consultant-listing-form-container">
    <div class="column">
        <div class="sales-consultant-listing-form">
            <mat-card class="horizinns-card more-blur white-blur">
                <mat-card-content>
                    <div>
                        <div style="display:flex; flex-direction: row; align-items: center; justify-content: center; margin-bottom: 2em;">
                            <mat-icon class="success" style="height: 40px; width: 40px; font-size: 40px; margin-right: 0.2em;">check_circle</mat-icon>
                            <h2>Data Applied</h2>
                        </div>
                        Your data has been applied to the form. Please review. If no changes are needed you may move forward. If a revision is needed, go back and make your change.
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="column">
        <mat-card class="horizinns-card even-more-blur white-blur center document-preview-card">
            <mat-card-content>
                <app-document-preview [pdfSrc]="pdfUrlForPreview"></app-document-preview> 
            </mat-card-content>
        </mat-card>
    </div>
</div>


<!-- <app-document-preview [pdfSrc]="pdfUrlForPreview"></app-document-preview>  -->
